<template>
  <v-col cols="4" sm="4">
    <div class="gif-image">
      <v-img ref="image" v-show="gifPreviewSrc" :src="gifPreviewSrc" aspect-ratio="1.7" @click="selectGif">
        <v-btn icon class="gif-delete-icon" v-if="isPreview" @click="deleteGif">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-img>
    </div>
  </v-col>
</template>
<script>
export default {
  name: 'SmsGiphyItem',

  components: {},

  props: {
    gif: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    gifPreviewSrc() {
      return this.small
        ? this.gif.images.fixed_width_small.url
        : this.gif.images.fixed_width_downsampled.url;
    }
  },

  methods: {
    async selectGif() {
      if (!this.isPreview) {
        const file = await this.$http
          .get(this.gif.images.fixed_width_downsampled.url, { responseType: 'blob' })
          .then(({ data }) => data);
        this.$root.$emit('select-gif', { ...this.gif, file });
      }
      this.$root.$emit('close-pickers');
    },
    deleteGif() {
      this.$root.$emit('remove-attached');
    }
  }
};
</script>
<style scoped>
.gif-image {
  cursor: pointer;
}
.gif-delete-icon {
  position: absolute;
  z-index: 100;
  color: #ffffff !important;
  right: 0;
}
</style>
